<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="row">
            <div class="col-9">
                <div class="form-group">
                    <label for="message_name" class="mt-1">Message Name:</label>
                    <input v-model="message.name" type="text" class="form-control" name="message_name"
                           id="message_name">
                    <div v-if="$v.message.name.$error">
                        <div class="text-danger" v-if="!$v.message.name.required">Name is required.</div>
                        <div class="text-danger" v-if="!$v.message.name.maxLength">Name must not exceed
                            {{$v.message.name.$params.maxLength.max }} characters.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="message_subject">Message Subject:</label>
                    <small class="form-text text-muted mt-0">
                        You can use here: Static tags [ ], Dynamic tag { } and Live Dynamic Tag {value 1|value 2|value 3}
                    </small>
                    <input v-model="message.subject" type="text" class="form-control"
                           name="message_subject" id="message_subject" ref="subj" @focus="setFocus('subjectOn')">
                    <div v-if="$v.message.subject.$error">
                        <div class="text-danger" v-if="!$v.message.subject.required">Subject is required.</div>
                        <div class="text-danger" v-if="!$v.message.subject.maxLength">Subject must not exceed
                            {{$v.message.subject.$params.maxLength.max }} characters.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="contentTextArea">Message HTML Content:</label>
                    <small class="form-text text-muted mt-0 mb-2">
                        You can use here: Static tags [ ], Dynamic tag { } and Live Dynamic Tag {value 1|value 2|value 3}
                    </small>
                    <textarea id="contentTextArea" v-model="message.htmlContent" placeholder="HTML source code"
                              class="form-control border border-bottom-0" rows="15" style="resize:vertical"
                              @focus="setFocus('contentOn')" ref="content"></textarea>
                    <div v-if="$v.message.htmlContent.$error">
                        <div class="text-danger" v-if="!$v.message.htmlContent.required">HTML Content is required.</div>
                    </div>
                </div>
                <div class="row">
                    <div class="ml-auto">
                        <button class="mx-2 btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                @click.prevent="showPreview">
                            Preview
                        </button>
                        <button class="mx-3 btn btn-success btn-rounded text-uppercase waves-effect waves-light">
                            Save
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div style="height:240px;">
                    <treeselect placeholder="Static Content"
                                :always-open="true"
                                :max-height="200"
                                :options="globalTagSelect"
                                :load-options="loadStaticTags"
                                @select="insertGlobalTagAtCursor"/>
                </div>
                <div>
                    <treeselect placeholder="Dynamic Content"
                                :always-open="true"
                                :max-height="300"
                                :options="dynamicTagSelect"
                                :load-options="loadDynamicTags"
                                @select="insertTagAtCursor"/>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import {required, maxLength} from 'vuelidate/lib/validators';
    import MessageService from '../../services/MessageService';
    import GlobalTagService from '../../services/GlobalTagService';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import TagService from '../../services/TagService';

    export default {
        name: 'MessageForm',
        props: ['id'],
        components: {
            Treeselect
        },
        data() {
            return {
                message: {
                    id: null,
                    name: null,
                    subject: null,
                    htmlContent: null
                },
                errors: {},
                globalTagSelect: null,
                dynamicTagSelect: null,
                focusStatus: '',
                defaultCode: '<!DOCTYPE html>\n' +
                    '<html lang="en">\n' +
                    '<head>\n' +
                    '  <title></title>\n' +
                    '  <meta charset="UTF-8">\n' +
                    '  <meta name="viewport" content="width=device-width, initial-scale=1">\n' +
                    '  <meta http-equiv="X-UA-Compatible" content="ie=edge">\n' +
                    '</head>\n' +
                    '<body>\n' +
                    '\n' +
                    '</body>\n' +
                    '</html>',
            }
        },
        mounted() {
            if (this.id) {
                MessageService.getMessage(this.id).then(response => {
                    this.message = response.data;
                    this.$emit('hidePreloader', true);
                });
            } else {
                this.message.htmlContent = this.defaultCode;
            }
        },
        validations: {
            message: {
                name: {required, maxLength: maxLength(100)},
                subject: {required, maxLength: maxLength(100)},
                htmlContent: {required}
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;

                let submitMethod = null;
                if (this.id) {
                    submitMethod = MessageService.updateMessage(this.id, JSON.stringify(this.message));
                } else {
                    submitMethod = MessageService.createMessage(JSON.stringify(this.message));
                }

                submitMethod.then(response => {
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                        this.$router.push({name: 'messages'});
                    }
                });
            },
            insertGlobalTagAtCursor(tag) {
                if (!tag.label) return false;
                this.insertFunction(tag.label);
            },
            insertTagAtCursor(tag) {
                if (!tag.label) return false;
                this.insertFunction('{' + tag.label + '}');
            },
            insertFunction(toInsert) {
                if (this.focusStatus === 'subjectOn') {
                    let start = this.$refs.subj.selectionStart;
                    this.$refs.subj.setRangeText(toInsert);
                    this.$refs.subj.selectionStart = this.$refs.subj.selectionEnd = start + toInsert.length;
                    let e = document.createEvent("UIEvent");
                    e.initEvent("input", true, false);
                    this.$refs.subj.dispatchEvent(e);
                    this.message.subject = this.$refs.subj.value
                } else if (this.focusStatus === 'contentOn') {
                    let start = this.$refs.content.selectionStart;
                    this.$refs.content.setRangeText(toInsert);
                    this.$refs.content.selectionStart = this.$refs.content.selectionEnd = start + toInsert.length;
                    let e = document.createEvent("UIEvent");
                    e.initEvent("input", true, false);
                    this.$refs.content.dispatchEvent(e);
                    this.message.htmlContent = this.$refs.content.value
                }
            },
            setFocus(element) {
                this.focusStatus = element;
            },
            showPreview() {
                MessageService.getMessagePreview(this.message, null, null).then(response => {
                    if (response.status === 200) {
                        let previewWindow = window.open();
                        previewWindow.document.open();
                        previewWindow.document.write(response.data.html);
                        previewWindow.document.close();
                    }
                });
            },
            loadDynamicTags({callback}) {
                TagService.getTagSelect().then(response => {
                    this.dynamicTagSelect = response.data['hydra:member'].map(tag => {
                        return {id: tag.name, label: tag.name}
                    });
                    callback();
                });
            },
            loadStaticTags({callback}) {
                GlobalTagService.getTagList().then(response => {
                    this.globalTagSelect = response.map(tag => {
                        return {id: tag, label: tag};
                    });
                    callback();
                });
            }
        }
    }
</script>

<style scoped>

</style>

